import { render, staticRenderFns } from "./CourseDetails.vue?vue&type=template&id=98b6cd36&scoped=true"
import script from "./CourseDetails.vue?vue&type=script&lang=js"
export * from "./CourseDetails.vue?vue&type=script&lang=js"
import style0 from "./CourseDetails.vue?vue&type=style&index=0&id=98b6cd36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b6cd36",
  null
  
)

export default component.exports